/**
 * v-auth
 * 按钮权限指令
 */
import { useAuthStore } from "@/stores/modules/auth";
import type { Directive, DirectiveBinding } from "vue";

const auth: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const { value } = binding;
    const authStore = useAuthStore();
    if (value.length) {
      const hasPermission = authStore.authButtonListGet.includes(value);
      if (!hasPermission) el.remove();
    } else {
      throw new Error(`格式为sys:rack:save..`);
    }
  }
};

export default auth;
